<form class="form_operation"
[formGroup]="formGroup"
(ngSubmit)="submit()">
<mat-form-field appearance="outline" class="w-100">
    <mat-label>Tasa</mat-label>
    <input matInput formControlName="rate"
    (keyup)="changeCalculationInput()"
    mask="separator"
    thousandSeparator="."
    />
    <mat-icon matSuffix>percent</mat-icon>
    <mat-hint *ngIf="controls['rate'].touched && controls['rate'].invalid" class="error-msg">
      <div
        class="text-error"
        *ngIf="controls['rate'].errors && controls['rate'].errors['required']"
      >
        Este Campo es requerido
      </div>
      <div class="text-error" *ngIf="controls['rate'].errors['min']">Valor invalido</div>
    </mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Porcentaje de Pago Inicial</mat-label>
    <input type="number" matInput 
    decimalMarker=","
    formControlName="downPaymentPercentage" 
    (keyup)="changeCalculationInput()"
    />
    <mat-icon matSuffix>percent</mat-icon>
    
    <mat-hint
      *ngIf="
        controls['downPaymentPercentage'].touched && controls['downPaymentPercentage'].invalid
      "
      class="error-msg"
    >
      <div
        class="text-error"
        *ngIf="
          controls['downPaymentPercentage'].errors &&
          controls['downPaymentPercentage'].errors['required']
        "
      >
        Este Campo es requerido
      </div>
      <div class="text-error" *ngIf="controls['downPaymentPercentage'].errors['min']">Valor invalido</div>
      <div class="text-error" *ngIf="controls['downPaymentPercentage'].errors['max']">Porcentaje superior al 100%</div>
    </mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Plazo</mat-label>
    <input type="number" matInput formControlName="plazo" (keyup)="changeCalculationInput()"/> <span style="position: absolute; margin-left: -20px; font-weight: bold;">Dias</span>
    <mat-hint class="error-msg" *ngIf="controls['plazo'].touched && controls['plazo'].invalid">
      <div class="text-error" *ngIf="controls['plazo'].errors && controls['plazo'].errors['required']">
        Este campo es requerido
      </div>
      <div class="text-error" *ngIf="controls['plazo'].errors && controls['plazo'].errors['min']">
        Valor invalido
      </div>
    </mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Costos Operativos</mat-label>
    <input
      matInput
      mask="separator"
      thousandSeparator="."
      decimalMarker=","
      formControlName="operationalCost"
      (keyup)="changeCalculationInput()"
    />
    <mat-icon matSuffix>attach_money</mat-icon>
    <mat-hint
      *ngIf="controls['operationalCost'].touched && controls['operationalCost'].invalid"
      class="error-msg"
    >
      <div
        class="text-error"
        *ngIf="
          controls['operationalCost'].errors && controls['operationalCost'].errors['required']
        "
      >
        Este Campo es requerido
      </div>
    </mat-hint>
  </mat-form-field>
  
  <div class="w-100">
    <mat-label style="font-weight: bold;">Precio Diferencia</mat-label>
    <p>
      {{ 
        factoringCalculation?.priceDifference
          ? (factoringCalculation?.priceDifference | currency:'CLP':'symbol')
          : "-" 
      }}
    </p>
  </div>

  <div class="w-100">
    <mat-label style="font-weight: bold;">Tasa Total</mat-label>
    <p>
      {{ 
        factoringCalculation?.allInRate
          ? (factoringCalculation?.allInRate + '%')
          : "-" 
      }}
    </p>
  </div>

  <div class="w-100">
    <mat-label style="font-weight: bold;">Impuesto sobre costo operativo</mat-label>
    <p>
      {{ 
        factoringCalculation?.operationalCostTax
          ? (factoringCalculation?.operationalCostTax | currency:'CLP':'symbol')
          : "-" 
      }}
    </p>
  </div>

  <div class="w-100" >
    <mat-label style="font-weight: bold;">Monto Financiamiento</mat-label>
    <p>
    {{
      factoringCalculation?.financedAmount
      ? (factoringCalculation?.financedAmount | currency:'CLP':'symbol')
      : "-" 
    }}      
    </p>
  </div>

  <div class="w-100">
    <mat-label style="font-weight: bold;">Monto de Transferencia</mat-label>
    <p>
      {{
        factoringCalculation?.transferAmount
        ? (factoringCalculation?.transferAmount | currency:'CLP':'symbol')
        : "-" 
      }}
    </p>
  </div>
  <div class="w-100">
    <button mat-raised-button (click)="calculateOperation()">Calcular</button>
  </div>
</form>